import { ITag } from '../..';

export interface IBundlesTags {
  bundleId: string;
  tags: ITag[];
}
